import { useEffect } from 'react';
import {
  type Listener,
  qontoWebsocket,
  type QontoWebsocketOptions,
} from '@repo/runtime-kit/websocket/websocket';

/**
 * Subscribe to a websocket event and unsubscribe when unmounting.
 *
 * Use a memoized callback as the listener
 *
 * Example:
 * ```js
 * useQontoWebsocket(
 *   'my-event',
 *   useCallback((payload: EventPayload) => {
 *     // handle logic on event here
 *   }, [])
 * );
 * ```
 */
export function useQontoWebsocket(
  event: string,
  listener: Listener,
  options?: QontoWebsocketOptions & { enabled?: boolean }
) {
  const enabled = options?.enabled ?? true;

  useEffect(() => {
    // oxlint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
    if (enabled) {
      return qontoWebsocket.subscribe(event, listener, { global: options?.global });
    }
  }, [event, enabled, listener, options?.global]);
}
